import React from 'react';
import { useReactiveVar } from '@apollo/client';
import HeaderLinks from './HeaderLinks';
import NavigationMenuExpand from './navigation-menu/NavigationMenuExpand';
import { systemRole } from '../../apollo/cache';

/**
 * @typedef {object} HeaderProps
 * @property {boolean} [showMenuIcon]
 */

/**
 * @param {HeaderProps} props
 */
const Header = props => {
  const { showMenuIcon = true } = props;

  const role = useReactiveVar(systemRole);

  return (
    <header className='header'>
      <nav id='headerContainer' aria-label='Main'>
        <div id='headerLeftContainer'>
          {showMenuIcon ? <NavigationMenuExpand /> : null}
          {role ? <span data-testid='role-title'>{role.DisplayName}</span> : null}
        </div>
        <menu className='headerRightContainer' aria-label='Setting Menu'>
          <HeaderLinks />
        </menu>
      </nav>
    </header>
  );
};

export default Header;
